<template>
  <div class="shop-content">
    <div class="appr-item" v-for="item in list" :key="item.soNumber">
      <div class="order" @click="goInfo(item.soNumber)">
        <div class="number">
          <span>订单号：{{item.soNumber}}</span>
          <span class="status" :class="item.soStatusEN==0||item.soStatusEN==1?'corange':''">{{item.soStatusCN}}</span></div>
        <div class="content" v-for="good in item.goodsList" :key="good.goodId">
          <div class="content-img">
            <img :src="good.goodLogo + '?imageView2/1/w/480/h/480'">
          </div>
          <div class="content-box">
            <div class="name">{{good.goodName}}</div>
            <div class="content-price">
              <span class="price"><span class="fz18">¥</span>{{item.orderAmount}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="action">
        <!-- 1待付款; 联系客服 取消订单 立即支付
            2待卖家发货； 申请退款 联系客服
            3卖家已发货；联系客服 查看物流
            4待胖虎鉴定中心鉴定；联系客服 查看物流

            5 鉴定通过待发货（第三方） ；联系客服 
            待胖虎发货 ：联系客服 ；查看物流
            17调货中；联系客服 查看物流
            7胖虎已发货；联系客服 查看物流 确认收货
            6 鉴定未通过待退款；联系客服
            8 鉴定未通过已退款；联系客服 查看退款
            9已收货 ；删除订单 联系客服
            14已退款；联系客服 查看退款
            16已付款待确认；联系客服 更新凭证

            19退款中；联系客服
            20拒绝退款；联系客服 查看原因
            100交易成功；删除订单
            101交易关闭； 删除订单

            待到店自提：联系客服 确认收货
            -->
        <div class="tools">
          <a href="javascript:;" class="btn" v-if="item.soStatusEN=='2'" @click="refundOrder(item.soNumber)">申请退款</a>
          <a href="javascript:;" class="btn" v-if="item.soStatusEN != '100' && item.soStatusEN != '101'" @click="kefu">联系客服</a>
          <a href="javascript:;" class="btn" v-if="item.soStatusEN == '1'" @click="cancelOrder(item.soNumber)">取消订单</a>
          <a href="javascript:;" class="btn btn-warning" v-if="item.soStatusEN=='1'" @click="goPay(item.goodsList, item.soNumber)">立即支付</a>

          <a href="javascript:;" class="btn btn-warning" v-if="item.soStatusEN=='3' || item.soStatusEN=='4' || item.soStatusEN=='5' || item.soStatusEN=='7' || item.soStatusEN=='17'" @click="logistics(item.soNumber)">查看物流</a>

          <a href="javascript:;" class="btn btn-warning" v-if="item.soStatusEN=='7' || item.soStatusEN=='21'" @click="confirmOrder(item.soNumber)">确认收货</a>
          <a href="javascript:;" class="btn btn-warning" v-if="item.soStatusEN=='8' || item.soStatusEN=='14'" @click="refund">查看退款</a>

          <a href="javascript:;" class="btn btn-warning" v-if="item.soStatusEN=='16'" @click="goCertificate(item.soNumber)">更新凭证</a>
          <a href="javascript:;" class="btn btn-warning" v-if="item.soStatusEN=='20'" @click="checkReason(item.soNumber)">查看原因</a>
          <a href="javascript:;" class="btn" v-if="item.soStatusEN=='9' || item.soStatusEN=='100' || item.soStatusEN=='101'" @click="deleteOrder(item.soNumber)">删除订单</a>
        </div>
      </div>
    </div>
    <!-- <van-action-sheet v-model="showPay" title="支付">
      <div class="actions-pay">
        <div class="price">¥{{currPayPrice}}</div>
        <van-radio-group v-model="paytype">
           <van-cell-group>
            <van-cell title="网银转账" clickable @click="paytype='5'">
              <svg-icon slot="icon" iconClass="unionpay" class="ph-icon" style="margin-right: 10px;font-size:22px"></svg-icon>
              <van-radio name="5" checked-color="#FFD133" />
            </van-cell>
            <van-cell title="微信支付" clickable @click="paytype='2'">
              <van-icon slot="icon" name="wechat" color="#00C800" size="22px" style="margin-right: 10px" />
              <van-radio name="2" checked-color="#FFD133" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <button class="btn" @click="pay">支付</button>
      </div>
    </van-action-sheet> -->

  </div>
</template>

<script>
import { getSystem, openApp, BrowserInfo } from '@/utils'
import { getWxUrl, orderCancel, orderDelete, orderConfirm, orderRefusereson } from '@/api/order'
export default {
  name: 'shopOrderItem',
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    ChannelId () {
      return this.$store.getters.apprChannelId
    },
    token () {
      return this.$store.getters.token || ''
    }
  },
  data () {
    return {
      paytype: '2',
      currIndex: 0,
      currPayPrice: 0,
      showPay: false
    }
  },
  methods: {
    goPay (goods, oid) {
      // 清理结算缓存
      this.$store.dispatch('BalanceOut')
      if (goods.length === 0) return false
      let gid = goods[0].goodId
      if (this.token) {
        let url = '/pay/balance/' + gid + '?oid=' + oid
        if (BrowserInfo().isWeixin) {
          getWxUrl({ url: url, label: 1 }).then(res => {
            location.href = res
          })
        } else {
          this.$router.push({ path: url })
        }
        // this.$router.push({ path: '/pay/balance/' + gid + "?oid=" + oid })
      } else {
        this.$router.push({ path: '/login?return_url=' + window.location.href })
      }
    },
    /**
     * @method 查看订单详情
     * @param {string} oid 订单ID
     */
    goInfo (oid) {
      this.$router.push({ name: 'shopOrderDetail', params: { oid: oid } })
    },
    kefu () {
      this.$emit('serve')
    },
    // 取消订单
    cancelOrder (oid) {
      this.$dialog.confirm({
        title: "提示",
        message: "是否确认取消订单？",
      }).then(() => {
        orderCancel({ soNumber: oid, userToken: this.token }).then(res => {
          this.$toast('订单已取消')
          this.$emit('fatherMethod');
        }).catch(error => {
          this.$toast(err)
        })
      }).catch(() => {
      })
    },
    // 申请退款
    refundOrder () {
      this.$dialog.confirm({
        title: '提示',
        message: '下载胖虎奢侈品APP申请退款',
        confirmButtonText: '去下载'
      }).then(() => {
        openApp('ponhu://')
      }).catch(() => {
      })
    },
    // 物流
    logistics (oid) {
      this.$router.push({ name: 'logistics', query: { oid: oid } })
    },
    // 确认收货
    confirmOrder(oid) {
      this.$dialog.confirm({
        title: "提示",
        message: "是否确认收货？",
      }).then(() => {
        orderConfirm({ soNumber: oid, userToken: this.token }).then(res => {
          this.$toast('确认收货成功')
          this.$emit('fatherMethod');
        }).catch(err => {
          this.$toast(err)
        })
      }).catch(() => {
      })
      
    },
    // 查看原因
    checkReason(oid) {
      orderRefusereson({ soNumber: oid, userToken: this.token }).then(res => {
        this.$dialog.alert({
          message: res,
          confirmButtonText: '知道了'
        })
      }).catch(err => {
        this.$toast(err)
      })
    },
    // 更新凭证
    goCertificate(oid) {
      this.$router.push({ name: 'Epay', params: { oid: oid } })
    },
    // 删除订单
    deleteOrder(oid) {
      this.$dialog.confirm({
        title: "提示",
        message: "是否确认删除订单？",
      }).then(() => {
        orderDelete({ soNumber: oid, userToken: this.token }).then(res => {
          this.$toast('订单已删除')
          this.$emit('fatherMethod');
        }).catch(err => {
          this.$toast(err)
        })
      }).catch(() => {
      })
      
    },
    // 退款
    refund() {
      this.$dialog.confirm({
        title: '提示',
        message: '下载胖虎奢侈品APP查看退款',
        confirmButtonText: '去下载'
      }).then(() => {
        openApp('ponhu://')
      }).catch(() => {
      })
    }

  }
}
</script>

<style lang="less" scoped>
.shop-content {
  .appr-item {
    margin-top: 24px;
    .order {
      background: #ffffff;
      padding: 30px;
      .number {
        color: #999;
        font-size:24px;
      }
      .status {
        font-size:24px;
        font-weight:500;
        float:right;
      }
      .content {
        padding-bottom: 20px;
        display:-webkit-box;
        display:-webkit-flex;
        position:relative;
        .content-img {
          margin-top: 30px;
          margin-right: 24px;
          width: 128px;
          height: 128px;
          text-align:center;
          img {
            width:100%;
            height:100%;
            vertical-align:top;
          }
        }
        .content-box {
          -webkit-box-flex:1;
          -webkit-flex:1;
          flex:1;
          min-width:0;
          margin-top: 30px;
          .name {
            font-weight:500;
            font-size: 28px;
            color: #333333;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-align: left;
            line-height: 1.3;
          }
        }
        .content-price {
          overflow:hidden;
          display:-webkit-box;
          line-height: 40px;
          .price {
            flex:1;
            position:absolute;
            font-size: 28px;
            bottom: 10px;
            color: #282828;
          }
        }
      }
    }
    .action {
      background: #ffffff;
      padding: 0 30px 40px 0;
      .tools {
        display: flex;
        justify-content:flex-end;
        .btn {
          display: inline-block;
          font-weight: 500;
          text-align: center;
          white-space: nowrap;
          vertical-align: middle;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          border:1px solid #999999;
          padding: 12px 22px;
          border-radius:28px;
          line-height: 36px;
          border-radius: 28px;
          margin-left: 24px;
          color: #999999;
          font-size:24px;
        }
        .sm {
          padding: .1rem .26rem;
        }
        .btn-warning {
          color: #282828;
          background-color: #FFD133;
          background-image: none;
          border-color: #FFD133;
        }
      }
    }
  }
}
.actions-pay {
  .price {
    height:60px;
    font-size:60px;
    font-weight:500;
    color:#282828;
    line-height:60px;
    text-align: center;
    padding: 24px 0;
  }
  .btn {
    margin-top: 100px;
    padding: 0;
    width: 100%;
    height: 100px;
    background: #FFD133;
    font-size:32px;
    font-weight:500;
    color: #282828;
    border: .01rem solid transparent;
    outline: none;
  }
}
</style>
